import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { X } from "lucide-react"

import { cn } from "../../lib/utils"

const DialogFeedback = DialogPrimitive.Root

const DialogTriggerFeedback = DialogPrimitive.Trigger

const DialogPortalFeedback = DialogPrimitive.Portal

const DialogCloseFeedback = DialogPrimitive.Close

const DialogOverlayFeedback = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "fixed inset-0 z-50 bg-black/30  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    )}
    {...props} />
))
DialogOverlayFeedback.displayName = DialogPrimitive.Overlay.displayName

const DialogContentFeedback = React.forwardRef(({ className, children, ...props }, ref) => (
  <DialogPortalFeedback>
    <DialogOverlayFeedback />
    <DialogPrimitive.Content
      ref={ref}
      // className={cn(
      //   "fixed left-[50%] top-[50%] max-h-[300px] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] md:rounded-lg rounded-lg",
      //   className
      // )}
      className={cn(
        "fixed left-1/2 top-1/2 z-50 grid w-auto max-w-[36rem] sm:max-w-[22rem] translate-x-[-50%] translate-y-[-50%] border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] md:rounded-lg rounded-lg",
        className
      )}
      {...props}>
      {children}
      <DialogPrimitive.Close
        className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
        <X className="h-4 w-4" />
        <span className="sr-only">Close</span>
      </DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </DialogPortalFeedback>
))
DialogContentFeedback.displayName = DialogPrimitive.Content.displayName

const DialogHeaderFeedback = ({
  className,
  ...props
}) => (
  <div
    className={cn("flex flex-col space-y-1.5 text-center sm:text-left overflow-hidden", className)}
    {...props} />
)
DialogHeaderFeedback.displayName = "DialogHeader"

const DialogFooterFeedback = ({
  className,
  ...props
}) => (
  <div
    className={cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)}
    {...props} />
)
DialogFooterFeedback.displayName = "DialogFooter"

const DialogTitleFeedback = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className={cn("text-lg font-semibold leading-none tracking-tight relative md:-right-[120px] -right-[119px] -bottom-[20px]", className)}
    {...props} />
))
DialogTitleFeedback.displayName = DialogPrimitive.Title.displayName

const DialogDescriptionFeedback = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Description
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props} />
))
DialogDescriptionFeedback.displayName = DialogPrimitive.Description.displayName

export {
  DialogFeedback,
  DialogPortalFeedback,
  DialogOverlayFeedback,
  DialogCloseFeedback,
  DialogTriggerFeedback,
  DialogContentFeedback,
  DialogHeaderFeedback,
  DialogFooterFeedback,
  DialogTitleFeedback,
  DialogDescriptionFeedback,
}
